import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../core/services/data.service';
import { IArticle } from '../../core/models/IArticle.type';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { AuthenticationService } from '../../core/services/authentication.service';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-guides',
  templateUrl: './guides.component.html',
  styleUrls: ['./guides.component.scss']
})
export class GuidesComponent implements OnInit {
  htmlContent: string;
  htmlTitle: string;
  htmlTags: string [] = [];
  guideId: number;
  showEditor: boolean;
  selectedRowIndex: number;
  showListArticles: boolean;
  idArticle: number;
  
  articles:IArticle[];
  displayedColumns: string[] = ['id', 'title', 'guide_id', 'tags', 'creationDate', 'updateDate'];
  dataSource = new MatTableDataSource<IArticle>();
  selection = new SelectionModel<IArticle>(true, []);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  subSink = new SubSink();

  constructor(private router: Router, private authService: AuthenticationService, private dataServices:DataService) { 
    this.showEditor = false;
    this.showListArticles = true;
  }

  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    this.dataSource.paginator = paginator;
  }

  ngOnInit(): void {
    this.getListGuides();
  }

  getListGuides(){
    this.subSink.add(this.dataServices.getGuides().subscribe(data=>{
        if(data){
          console.log("DATA", data)
          this.articles = data.result;
          this.dataSource.data = data.result;
        }
      })
    );
  }

  goBack(){
    this.showListArticles = true;
    this.showEditor = false;
    this.getListGuides();
  }

  addArticle(row){
    if(this.selectedRowIndex == row.id){
      this.hideEditor();
    }
    else{
      this.showEditor = true;
      this.selectedRowIndex = row.id;
      this.htmlTitle = row.title;
      this.dataServices.getGuide(row.guide_id).subscribe(data=>{
        this.guideId = data.result.id;
        this.htmlContent = data.result.guide;
      });
      this.getListGuides();
    }
  }

  hideEditor(){
    this.selectedRowIndex = null;
    this.htmlTitle = '';
    this.htmlContent = '';
    this.showEditor = false;
  }

  newArticle(){
    this.showListArticles = false;
    this.htmlTitle = '';
    this.htmlContent = '';
    this.showEditor = true;
  }

  postArticle(){
    this.dataServices.postGuide(this.htmlTitle, this.htmlContent).subscribe(data=>{ //this.environment, this.category
      console.log("DATA POST", data);
      if(data.status == 200){
        window.location.reload();
      }
    });
  }

  updateArticle(){
    this.dataServices.putGuide(this.selectedRowIndex, this.htmlTitle, this.guideId, this.htmlContent).subscribe(data=>{
      if(data.status == 200){
        window.location.reload();
      }
    });
  }

  deleteArticle(){
    this.dataServices.deleteGuide(this.selectedRowIndex).subscribe(data=>{
      this.getListGuides();
      this.hideEditor();
    });
  }

  

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
